import { z } from 'zod';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

const makeInput = bindUnvalidatableInputMaker();
const inTableImageInput = makeInput({
  schema: z.object({
    type: z.literal("Image"),
    title: z.string(),
    src: z.string(),
    altText: z.string().nullish().default(null)
  }),
  postprocessSchemaInput: ({
    title,
    src,
    altText
  }, context) => {
    return {
      id: `${context.taskId}-${context.rowIndex}-${context.index}`,
      nodeType: "in-table-image",
      title,
      src,
      alt: altText,
      meta: {
        rowIndex: context.rowIndex
      }
    };
  }
});

export { inTableImageInput };
//# sourceMappingURL=input.image.js.map
